import React from "react";
import { Tabs, Tab, Typography } from "@mui/material";
import { ColorsConstants } from "../cssUtils/constants";
import typography from "../cssUtils/typography";

const CustomTabs = ({ 
  value, 
  onChange, 
  tabs = [], 
  sx = {}, 
  tabSx = {},
  activeBgColor = ColorsConstants.primaryBackgroundColor,
  inactiveBgColor = "#F3F5F7",
  activeTextColor = "#fff",
  inactiveTextColor = "#6B7280",
  ...props 
}) => {
  // Find the index of the currently selected tab based on value
  const selectedIndex = tabs.findIndex(tab => tab.value === value);

  const handleChange = (event, newIndex) => {
    // Get the value of the newly selected tab and call onChange with that value
    const selectedTab = tabs[newIndex];
    if (selectedTab && onChange) {
      onChange(event, selectedTab.value);
    }
  };

  return (
    <Tabs
      value={selectedIndex === -1 ? 0 : selectedIndex}
      onChange={handleChange}
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      sx={{
        minHeight: 53,
        p: "4px",
        borderRadius: "10px",
        backgroundColor: "#F3F5F7",
        overflowX: "auto",
        "& .MuiTabs-flexContainer": {
          justifyContent: { xs: "flex-start", md: "space-between" },    
        },
        "& .MuiTabs-indicator": {
          display: "none",
        },
        ...sx,
      }}
      {...props}
    >
      {tabs.map((tab, index) => (
        <Tab
          key={index}
          label={
            <Typography
              sx={{
                ...typography.bodyLarge,
                fontWeight: 500,
                color: "inherit",
              }}
            >
              {tab.label}
            </Typography>
          }
          disabled={tab.disabled}
          sx={{
            flex: { xs: "0 0 auto", md: 1 },
            width: { xs: "auto", md: "100%" },
            textTransform: "capitalize",
            borderRadius: "10px",
            px: { xs: 1.5, sm: 3 },
            ml: index !== 0 ? 1 : 0,
            minHeight: 45,
            backgroundColor: selectedIndex === index ? activeBgColor : inactiveBgColor,
            color: selectedIndex === index ? activeTextColor : inactiveTextColor,
            "&.Mui-selected": {
              color: activeTextColor,
            },
            "&.Mui-disabled": {
              opacity: 0.5,
              cursor: "not-allowed",
            },
            whiteSpace: "nowrap",
            minWidth: 0,
            maxWidth: "100%",
            width: "100%",
            ...tabSx,
          }}
        />
      ))}
    </Tabs>
  );
};

export default CustomTabs;